import React from 'react'
import { LogoIcon } from 'transfix-ui/components/LogoIcon'
import { makeStyles, Box, Toolbar, AppBar } from 'transfix-ui/core'

const useAppBarStyles = makeStyles({
  logoContainer: {
    display: 'flex',
    flex: '1 1 auto',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    flex: '0 0 auto',
    width: 33.42,
    height: 26.94,
  },
})

/**
 * Navbar used inside <AppFrame />
 */
export const AppNavBar = () => {
  const classes = useAppBarStyles()
  return (
    <AppBar position='static' color='default'>
      <Toolbar>
        <Box className={classes.logoContainer}>
          <LogoIcon color='white' size='small' className={classes.logo} />
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default AppNavBar
